import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface Props {
  showMenu: boolean;
  onToggleMenu: () => void;
}

export const TopBar = ({ showMenu, onToggleMenu }: Props) => (
  <div className="top-bar">
    <FontAwesomeIcon icon="shield-cat" />
    <FontAwesomeIcon
      icon={showMenu ? 'times' : 'bars'}
      onClick={onToggleMenu}
      className="menu-toggle"
    />
  </div>
);
